/* ================================================================================
   Ancona Pass 17 — print & share (ancona-print.js)
   PDP "Print details" (native window.print) + guide/content "Print guide" / "Share
   guide" (native Web Share with a copy-link fallback). No PDF library, no network,
   no PII, no tracking params. Feature flag: this <script> tag's data-ancona-print
   attribute (tokens: product, guide). Absent → all; empty string → none.
   ================================================================================ */
(function () {
  'use strict';
  if (window.__anconaPrint) return;
  window.__anconaPrint = true;

  var script = document.currentScript;
  var featAttr = script ? script.getAttribute('data-ancona-print') : null;
  var FEATURES = (featAttr == null ? 'product,guide' : featAttr).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  function on(f) { return FEATURES.indexOf(f) !== -1; }

  function track(ev, payload) {
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push(Object.assign({ event: 'ancona:' + ev }, payload || {}));
      document.dispatchEvent(new CustomEvent('ancona:' + ev, { detail: payload || {} }));
    } catch (e) {}
  }

  var live = null;
  function announce(msg) {
    try {
      if (!live) {
        live = document.createElement('div');
        live.className = 'ancona-visually-hidden';
        live.setAttribute('aria-live', 'polite');
        live.setAttribute('role', 'status');
        document.body.appendChild(live);
      }
      live.textContent = '';
      window.setTimeout(function () { live.textContent = msg; }, 30);
    } catch (e) {}
  }

  function doShare(title, url, btn) {
    if (navigator.share) { navigator.share({ title: title, url: url })['catch'](function () {}); return; }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        announce('Link copied');
        if (btn) { var t = btn.textContent; btn.textContent = 'Link copied'; window.setTimeout(function () { btn.textContent = t; }, 2000); }
      })['catch'](function () { window.prompt('Copy this link:', url); });
    } else { window.prompt('Copy this link:', url); }
  }

  /* ---- PDP "Print details" (ships hidden, JS reveals; idempotent) -------------- */
  function initProduct() {
    var wrap = document.querySelector('.ancona-print');
    var btn = document.getElementById('AnconaPrintBtn');
    if (!btn) return;
    if (wrap) wrap.hidden = false;
    if (btn.dataset.anconaWired) return;
    btn.dataset.anconaWired = '1';
    btn.addEventListener('click', function () { track('product_print', { handle: btn.dataset.handle || '' }); window.print(); });
  }

  /* ---- Guide/content "Print" + "Share" (injected on page templates with an rte;
          the Contact page is excluded because it is a form, not an article) ------ */
  function initGuide() {
    if (window.location.pathname.indexOf('/pages/contact') !== -1) return;
    var title = document.querySelector('.main-page-title');
    var rte = document.querySelector('.shopify-section .rte');
    if (!title || !rte || document.querySelector('.ancona-guideactions')) return;

    var bar = document.createElement('div');
    bar.className = 'ancona-guideactions';
    var printBtn = document.createElement('button');
    printBtn.type = 'button'; printBtn.className = 'ancona-guideactions__btn';
    printBtn.textContent = 'Print guide';
    printBtn.addEventListener('click', function () { track('guide_print', {}); window.print(); });
    var shareBtn = document.createElement('button');
    shareBtn.type = 'button'; shareBtn.className = 'ancona-guideactions__btn';
    shareBtn.textContent = 'Share guide';
    shareBtn.addEventListener('click', function () { track('guide_share', {}); doShare(document.title, window.location.href, shareBtn); });
    bar.appendChild(printBtn); bar.appendChild(shareBtn);
    title.parentNode.insertBefore(bar, title.nextSibling);

    /* print-only source line so a printed guide carries its own URL */
    var purl = document.createElement('p');
    purl.className = 'ancona-print-only ancona-print__url';
    purl.textContent = window.location.href;
    rte.appendChild(purl);
  }

  function boot() {
    if (on('product')) { try { initProduct(); } catch (e) {} }
    if (on('guide')) { try { initGuide(); } catch (e) {} }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme-editor: re-reveal the PDP button after a product-section reload. */
  document.addEventListener('shopify:section:load', function () { if (on('product')) { try { initProduct(); } catch (e) {} } });
})();
